import * as Sentry from '@sentry/react';
import { TLogErrorOptions } from '../../typings/common';

export const reloadOnChunkError = (error: Error) => {
  const isPageReloaded = sessionStorage.getItem('chunkErrorPageReloaded');
  if (!isPageReloaded) {
    sessionStorage.setItem('chunkErrorPageReloaded', 'true');
    window.location.reload();
  } else {
    Sentry.captureException(
      new Error(`${error.name}. Page is already reloaded`),
      {
        contexts: {
          payload: {
            error,
          },
        },
      }
    );
  }
};

export const logError = (error: unknown, options?: TLogErrorOptions): void => {
  const { message, ...rest } = options || {};

  const errorInstance =
    error instanceof Error
      ? error
      : new Error(typeof error === 'string' ? error : String(error));

  console.error(message || errorInstance.message, errorInstance);

  Sentry.captureException(errorInstance, {
    contexts: {
      payload: rest,
    },
  });
};
